import AppRoutes from '@/router/routes'
import useMe from '@/hooks/useMe'
import useVConsole from '@/hooks/useVConsole'
import useValidateApp from '@/hooks/useValidateApp'
const App = () => {
  // 初始化只执行一次的hooks
  useVConsole()
  useValidateApp()
  useMe()

  return <AppRoutes />
}
export default App
